import type { ModelSpecification } from "@domain/generative-model/generative-model"

export const gpt54NanoSpecification: ModelSpecification = {
	name: "gpt-5.4-nano",
	provider: "openai",
	supportsReasoningEffort: true,
	supportedReasoningEfforts: ["xhigh", "high", "medium", "low", "none"],
	supportedContextItemTypes: [
		"user_message",
		"system_message",
		"developer_message",
		"reasoning",
		"function_call",
		"function_call_output",
		"model_message",
	],
	supportsStreaming: true,
	contextWindowSize: 400_000,
	maxOutputTokens: 128_000,
	supportsFunctionCalling: true,
	supportsStructuredOutput: true,
}
